import { InjectionToken } from '@angular/core';

/** Which Better Auth OIDC client registration this shell uses (`escrowtab-web` vs `escrowtab-admin`). */
export type EscrowtabOidcApp = 'web' | 'admin';

export const ESCROWTAB_OIDC_APP = new InjectionToken<EscrowtabOidcApp>(
  'ESCROWTAB_OIDC_APP',
  {
    providedIn: 'root',
    factory: (): EscrowtabOidcApp => 'web',
  },
);
